import { QuestionType } from '../../../../../API';

export const questionTypeFormatMap: { [key in QuestionType]: string } = {
  [QuestionType.MULTIPLE_CHOICE]: 'Multiple Choice',
  [QuestionType.SCALE]: 'Scale',
  [QuestionType.TEXT]: 'Text',
  [QuestionType.IMAGE_MULTIPLE_CHOICE]: 'Image Choice',
};
